import CustomAxios from "../../utility/customAxios";

export interface ToolMessagePair {
    tool_call_id: string;
    tool_call_message?: {
        role: string;
        content: string;
        tool_call_id?: string;
        tool_call_function_name?: string;
        tool_call_function_args?: string;
    };
    tool_response?: {
        role: string;
        content: string;
        tool_call_response_id?: string;
        tool_call_response_content?: string;
        ai_compressed_tool_call_response_content?: string;
    };
}

export interface ToolMessagesResponse {
    tool_messages: ToolMessagePair[];
}

export async function fetchToolMessages(toolCallIds: string[]): Promise<ToolMessagesResponse> {
    const response = await CustomAxios.post('/api/v1/guardian/tool-messages', {
        tool_call_ids: toolCallIds
    });
    return response.data;
}